const style = {
  wrapper: {
    margin: `15px -15px`
  },
  list: {
    // background: `#fbfbfb`,
  },
  row: {
    border: `1px solid transparent`,
    borderBottom: `1px solid #666`
  },
  header: {
    borderBottom: `1px solid #666`
  },
  p: {
    fontSize: `13px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/style/ColorBlind/list.js